import { Routes } from '@angular/router';
import { AuthGuard } from '@i7/shared';
import { AuthSemMenuGuard } from '../guards/auth-sem-menu.guard';

export const estRoutes: Routes = [
  {
    path: "monitor-estoque",
    loadChildren: () =>
      import("../pages/est/estoque/estoque-routing.module").then(
        (module) => module.EstoqueRoutingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "estoque-online",
    loadChildren: () =>
      import("../pages/est/estoque-online/estoque-online.module").then(
        (module) => module.EstoqueOnlineModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'etiqueta',
    loadChildren: () =>
      import(
        '../pages/est/etiqueta/etiqueta-routing.module'
      ).then((module) => module.EtiquetaRoutingModule),
    canActivate: [AuthGuard],
  },

  {
    path: 'requisicao',
    loadChildren: () =>
      import('../pages/est/requisicao/requisicao.module').then(
        (module) => module.RequisicaoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "movimentos",
    loadChildren: () =>
      import("../pages/est/movimentos/movimentos.module").then(
        (module) => module.MovimentosModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "reservas",
    loadChildren: () =>
      import("../pages/est/reservas/reservas.module").then(
        (module) => module.ReservasModule
      ),
    canActivate: [AuthSemMenuGuard],
  },
  {
    path: 'rastreabilidade',
    loadChildren: () =>
      import('../pages/est/rastreabilidade/rastreabilidade.module').then(
        (module) => module.RastreabilidadeModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'indice',
    loadChildren: () =>
      import('../pages/bas/indice/indice.module').then(
        (module) => module.IndiceModule
      ),
    canActivate: [AuthGuard],
  }
];
